export default "__VITE_ASSET__c60c0df9__"